/**
 * Timeout Interceptor.
 */

module.exports = function (_) {

    return function () {

        var timeout;

        return {

            request: function (request) {

                if (request.timeout) {
                    timeout = setTimeout(function () {
                        request.cancel();
                    }, request.timeout);
                }

                return request;
            },

            response: function (response) {

                clearTimeout(timeout);

                return response;
            }

        };
    };

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-resource/src/interceptor/timeout.js
// module id = 224
// module chunks = 1